enum OperatorListingFilterType {
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  USERNAME = "USERNAME",
  EMAIL = "EMAIL",
  STATUS = "STATUS",
}

export default OperatorListingFilterType;
